import styled from 'styled-components';

import { Image } from 'theme/images';

export const AppLinksSection = styled('section')`
  grid-column: span 2 / span 2;
  grid-column-start: 1;
  grid-row-start: 1;

  > :not([hidden]) ~ :not([hidden]) {
    margin-top: 8px;
    margin-bottom: 0;
  }

  @media (min-width: 1024px) {
    grid-column: span 4 / span 4;
    grid-column-start: 2;
    grid-row-start: 1;
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: flex-end;
    space-between: 24px;
    space-around: 0;

    > :not([hidden]) ~ :not([hidden]) {
      margin-right: 0;
      margin-left: 24px;
      margin-top: 0;
      margin-bottom: 0;
    }
  }
`;

export const AppLink = styled('a')`
  text-decoration: none;
  cursor: pointer;
  background-color: #111111;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 12px;
  padding-bottom: 12px;
  transition: all 0.3s ease-out;

  &:hover {
    transform: translateY(-0.25rem);
    box-shadow: 0px 8px 0px rgba(0, 0, 0, 0.08);
  }
`;

export const LegalContainer = styled('div')`
  grid-column: span 2 / span 2;
  grid-column-start: 1;
  margin-top: 56px;
  justify-content: flex-end;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  @media (min-width: 1024px) {
    grid-column: span 1 / span 1;
    grid-column-start: 5;
    grid-row-start: 4;
  }
`;

export const ContactDetailsSection = styled('section')`
  color: #5c5c5c;
  grid-column-start: 1;
  grid-row-start: 3;
  margin-top: 56px;
  font-size: 16px;
  font-weight: 200;

  @media (min-width: 1024px) {
    color: #c3c3c3;
    align-content: start;
    grid-column: span 1 / span 1;
    grid-column-start: 5;
    grid-row-start: 3;
    margin-top: 32px;
    text-align: right;
  }
`;

export const ContactDetailsContent = styled('div')`
  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    align-items: flex-end;
  }

  /* Stay stacked between lg and xl; only flip to a horizontal row at xl. */
  @media (min-width: 1280px) {
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
  }
`;

export const ContactAddress = styled('address')`
  font-style: normal;

  @media (min-width: 1024px) {
    display: contents;
  }

  @media (min-width: 1280px) {
    white-space: nowrap;
  }
`;

export const ContactAddressBreak = styled('br')`
  @media (min-width: 1024px) {
    display: none;
  }
`;

const contactLinkStyles = `
  color: inherit;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 200;
  text-decoration: none;
`;

export const ContactAddressLink = styled('a')`
  ${contactLinkStyles}
`;

export const ContactPhoneLink = styled('a')`
  ${contactLinkStyles}
  white-space: nowrap;
`;

export const ContactDivider = styled('hr')`
  border: 0;
  border-top: 1px solid #5c5c5c;
  margin: 16px 0;
  width: 24px;
  height: 0;
  flex-shrink: 0;

  /* Divider only becomes vertical once the row flips at xl. */
  @media (min-width: 1280px) {
    margin: 0;
    width: 1px;
    height: 20px;
    border: 0;
    background-color: #929292;
  }
`;

export const LegalText = styled('p')`
  color: #747474;
  text-align: center;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.02em;
  font-weight: 300;
  margin: 0;

  @media (min-width: 1024px) {
    text-align: right;
  }
`;

export const HollardLogo = styled(Image)`
  margin-top: 1.5rem;
  height: 1.5rem;
  align-self: center;

  @media (min-width: 1024px) {
    align-self: flex-end;
  }
`;

export const LogoLinkContainer = styled('a')`
  display: none;
  align-self: center;
  text-decoration: none;
  cursor: pointer;
  margin-top: 16px;

  @media (min-width: 1024px) {
    grid-column-start: 1;
    grid-row-start: 1;
    display: block;
  }
`;

export const NavContainer = styled('nav')`
  color: #a0aec0;
  grid-column: span 2 / span 2;
  grid-column-start: 1;
  grid-row-start: 2;
  grid-row-end: span 2;
  display: grid;
  /* Subgrid lets ContactDetails (a sibling, not a child) drop into nav's empty
     row-2/col-1 cell with tracks that line up exactly with the nav sections. */
  grid-template-columns: subgrid;
  grid-template-rows: subgrid;
  column-gap: 2rem;

  font-size: 16px;
  line-height: 12px;
  letter-spacing: 0px;
  font-weight: 200;

  @media (min-width: 1024px) {
    grid-column: span 3 / span 3;
    grid-row: span 3 / span 3;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: none;
    column-gap: 0px;
  }
`;

export const NavLinkContainer = styled('div')`
  margin-top: 56px;
  display: flex;
  flex-direction: column;

  > :not([hidden]) ~ :not([hidden]) {
    margin-top: 16px;
    margin-bottom: 0;
  }

  /* Match marketing footer: Company sits in col 2 on the 2-col mobile nav grid */
  &:last-child {
    grid-column-start: 2;
  }

  @media (min-width: 1024px) {
    margin-top: 64px;

    &:last-child {
      grid-column-start: auto;
    }
  }
`;

export const NavText = styled('p')`
  font-weight: 500;
  color: #ffffff;
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 0;
  height: 24px;
`;

export const NavLink = styled('a')`
  display: block;
  text-decoration: none;
  cursor: pointer;
  color: #ffffff;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.05em;
  font-weight: 200;
`;

export const SocialMediaSection = styled('section')`
  grid-column: span 2 / span 2;
  grid-column-start: 1;
  margin-top: 56px;
  display: flex;
  align-items: center;
  line-height: 24px;
  justify-content: center;

  > :not([hidden]) ~ :not([hidden]) {
    margin-right: 0;
    margin-left: 32px;
  }

  @media (min-width: 1024px) {
    grid-column: span 1 / span 1;
    grid-column-start: 5;
    grid-row-start: 2;
    margin-top: 32px;
    align-items: flex-end;
    justify-content: flex-end;
  }
`;

export const SocialMediaLink = styled('a')`
  display: block;
  height: 32px;
  text-decoration: none;
  cursor: pointer;
`;
